import React, { useEffect, useState } from "react";
import Plot from "react-plotly.js";
import {fetchTable} from "../../api";

const IntradayHeatmap = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchTable("intraday_heatmap",'n50')
      .then((res) => setData(res))  // Axios puts JSON in res.data
      .catch((err) => console.error("Error fetching heatmap:", err));
  }, []);

  console.log('INTRADAY',data)
  const symbols = data.map((d) => d.symbol);
  const volumes = data.map((d) => (d.computed_volume/1e7).toFixed(2));
  const changes = data.map((d) => d.change_percent);

  return (
<Plot
  data={[
    {
      type: "treemap",

      labels: symbols,

      parents: symbols.map(() => ""),

      values: volumes,

      marker: {
        colors: changes,

        colorscale: [
          [0, "#ef4444"],   // red-500
          [0.5, "#facc15"], // yellow-400
          [1, "#22c55e"]    // green-500
        ],

        colorbar: {
          title: {
            text: "Change %",
            font: {
              color: "#e4e4e7"
            }
          },

          tickfont: {
            color: "#e4e4e7"
          }
        }
      },

      textfont: {
        color: "white",
        size: 14
      },

      texttemplate:
        "%{label}<br>Vol %{value:.2f} Cr",
    },
  ]}

  layout={{

    title: {
      text: "Intraday Activity Heatmap",
      font: {
        color: "#ffffff",
        size: 20
      }
    },

    paper_bgcolor: "#ffffff",

    plot_bgcolor: "#ffffff",

    font: {
      color: "#334155"
    },

    margin: {
      t: 60,
      l: 10,
      r: 10,
      b: 10
    },

    autosize: true,

    height: 550,

    width: 550
  }}

  config={{
    responsive: true,
    displaylogo: false
  }}
/>  );
};

export default IntradayHeatmap;
